import { get, post } from '../utils/http';

//同步privy tokend登录状态
export function Login() {
  return post('/users/login')
}

export function getAgentList(params) {
  return get("/agents/get_agent_list",params)
}

export function getAgentSearch(data) {
  return get("/agents/search",data)
}

export function getAgentDetail(data) {
  return get("/agents/get_agent_info",data)
}

export function uploadAgentCover(data,type) {
  return post("/agents/upload_agent_cover",data,type)
}

export function createAgent(data) {
  return post("/agents/create",data)
}

export function getSummaryAnalysis(address,data) {
  return get(`summary/analysis/${address}`,data)
}

export function getUserPersonas() {
  return get('/chats/user/personas')
}

export function getPersonalAI(data) {
  if (data) {
    return post('/chats/user/personas', data)
  }
  return get('/chats/user/personas')
}

export function sendChat(data) {
  return post('/chats/send', data)
}

export function getChatMessages(data) {
  return get('/chats/messages', data)
}

export function getChatSessionSettings(data) {
  return get('/chats/session/settings', data)
}

export function updateChatSessionSettings({ persona_id, agent_id, auto_reply_enabled }) {
  return post(`/chats/session/settings?persona_id=${persona_id}&agent_id=${agent_id}`, { auto_reply_enabled })
}

export function getUserAgents() {
  return get('/agents/get_user_agents')
}

export function clearChatSession(agentId, personaId) {
  return post(`/chats/session/clear?agent_id=${agentId}&persona_id=${personaId}`)
}